import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { loadFromStorage, saveToStorage } from "./utils/cartStorage";
import TopNav from "./TopNav";


const buyerInfo = loadFromStorage("buyerInfo", {});

export default function PaymentPage({cart}) {
  const navigate = useNavigate();
  const [paymentMethod, setPaymentMethod] = useState(() => {
    //console.log(`payment method: ${loadFromStorage("paymentMethod")}`); // .code, not set at first run...
    return loadFromStorage("paymentMethod") || getPaymentMethods()[0];

    // // load from backend?
    // const methods = getPaymentMethods();

    // const stored = loadFromStorage("paymentMethod");
    // return methods.find(m => m.code === stored?.code) || methods[0]; // always an object
  });

  useEffect(() => {
    saveToStorage("paymentMethod", paymentMethod);
  }, [paymentMethod]);

  if (!buyerInfo || buyerInfo == {} || !buyerInfo.name || !cart || cart.length == 0) {
      return (
          <>
              <TopNav cart={cart} />
              <div className="pane dark_pane">
                  <div className="left">
                      <h2>Nothing here...</h2>
                      <p>Your cart is empty</p>
                  </div>
              </div>
          </>
      );
  }

  const methods = getPaymentMethods();

  return (
     <div>
        <script type="text/javascript"  language="JavaScript">console.log("loading page...")</script>
        <TopNav cart={cart} />
        <div className="pane dark_pane">
          <div className="left_right_container">
            <div className="left">
                <h2>Payment</h2>
                <div className="checkout-form">
                        {methods.map((method, index) => (
                            <div key={`payment-container-${method.code}`} className="form-group">
                                {index === 0 && (<label>Method</label>)}
                                {index > 0 && (<label />)}
                                <div className="radio-options radio-group">
                                    <label className={`wide ${paymentMethod.code === method.code ? 'checked' : ''}`}>
                                    <input
                                        type="radio"
                                        name="paymentMethod"
                                        value={method.code}
                                        checked={paymentMethod === method}
                                        onChange={() => setPaymentMethod(method)}
                                    />
                                    <span>{method.displayName}</span>
                                    <img alt={method.code} src={`media/${method.code}.png`} />
                                    </label>                                    
                                </div>
                            </div>
                        ))}
                    <div className="form-group">
                      <button
                          className="add"
                          onClick={() => navigate('/checkout')}>Back</button>
                      <button 
                        type="button" 
                        className="add" 
                        onClick={() => navigate('/order-confirmation')} 
                        disabled={!paymentMethod || !paymentMethod.code?.length}>
                        Continue
                      </button>
                    </div>
                </div>
            </div>
          </div>
        </div>
    </div>
  );
}

export function getPaymentMethods() {
  return [
    { displayName: "iDeal", code: "ideal" },
    { displayName: "Credit Card", code: "creditcard" },
    { displayName: "Trustly", code: "trustly" },
    { displayName: "Klarna", code: "klarna" },
    { displayName: "PayPal", code: "paypal" },
    // { displayName: "Pay by Bank", code: "paybybank" }
  ];
}
